import script from "./faqs-setup.vue?vue&type=script&lang=js"
export * from "./faqs-setup.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__